module.exports = __webpack_public_path__ + "static/media/cms_white.04d5ab97.svg";